 <div id="siteTable" #tableWrapper>
    <app-table
      [AddBulkaction]="true"
      [buttonTitle]="header"
      [SiteDropDown]="true"
  ></app-table>
  </div>